import { AuthGuard } from './_guards';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { LoginModule } from './login/login.module';
import { SignupModule } from './signup/signup.module';
import { DashboardModule } from './dashboard/dashboard.module';


import { AlertComponent } from './alert/alert.component';
import { AlertService } from './alert/alert.service';
import { AuthenticationService } from './login/authentication.service';
import { RpwModule } from './resetPassword/rpw.module';
import { RpwService } from './resetPassword/rpw.service';
import { SecModule } from './sec/sec.module';
import { SecService } from './sec/sec.service';
import { SharedModule } from './shared/shared.module';
import { SignupService } from './signup/signup.service';

@NgModule({
  declarations: [
    AppComponent,
    AlertComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(routes),
    LoginModule,
    SignupModule,
    RpwModule,
    SecModule,
    SharedModule
    //    DashboardModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "sv-SE" },
    AlertService,
    AuthenticationService,
    SecService,
    RpwService,
    SignupService,
    AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts